import { render, staticRenderFns } from "./CTooltip.vue?vue&type=template&id=9cf7478a&scoped=true"
import script from "./CTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CTooltip.vue?vue&type=style&index=0&id=9cf7478a&prod&lang=less&scoped=true"
import style1 from "./CTooltip.vue?vue&type=style&index=1&id=9cf7478a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf7478a",
  null
  
)

export default component.exports